module.exports = {
  dimensions: {
    width: 143,
    height: 71
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  nine: {
    top: 3,
    left: 0,
    right: 0,
    bottom: 0
  },
  content: {
    top: 3,
    left: 0,
    right: 0,
    bottom: 0
  }
};